const iconList= [
    {
        "id": 1,
        "original_english": "Accounts & Bills",
        "english": "Accounts & Bills",
        "original_arabic": "الحسابات و الفواتير",
        "arabic": "الحسابات و الفواتير",
        "btns": "electricity_connection"
    },
    {
        "id": 2,
        "original_english": "Report an Outage",
        "english": "Report an Outage",
        "original_arabic": "بلاغ انقطاع الخدمة الكهربائية",
        "arabic": "بلاغ انقطاع الخدمة الكهربائية",
        "btns": "raise_a_customer_complaints"
    },
    {
        "id": 3,
        "original_english": "Track Request",
        "english": "Track Request",
        "original_arabic": "متابعة الطلبات",
        "arabic": "متابعة الطلبات",
        "btns": "new_request"
    },
    {
        "id": 4,
        "original_english": "Safety Services",
        "english": "Safety Services",
        "original_arabic": "خدمات لسلامتك",
        "arabic": "خدمات لسلامتك",
        "btns": "view_my_bill"
    },
    {
        "id": 5,
        "original_english": "Agent Support",
        "english": "Agent Support",
        "original_arabic": "تواصل معنا",
        "arabic": "تواصل معنا",
        "btns": "display_my_accounts"
    },
    {
        "id": 6,
        "original_english": "Account Information",
        "english": "Account Information",
        "original_arabic": "معلومات الحساب",
        "arabic": "معلومات الحساب",
        "btns": "check_status"
    },
    {
        "id": 7,
        "original_english": "Bills",
        "english": "Bills",
        "original_arabic": "فواتير",
        "arabic": "فواتير",
        "btns": "power_outage_due_to_fire"
    },
    {
        "id": 8,
        "original_english": "Fixed Bills",
        "english": "Fixed Bills",
        "original_arabic": "الفواتير الثابتة",
        "arabic": "الفواتير الثابتة",
        "btns": "complete_power_outage"
    },
    {
        "id": 9,
        "original_english": "Due to a fire",
        "english": "Due to a fire",
        "original_arabic": "بسبب حريق",
        "arabic": "بسبب حريق",
        "btns": "partial_power_outage"
    },
    {
        "id": 10,
        "original_english": "Complete",
        "english": "Complete",
        "original_arabic": "كامل",
        "arabic": "كامل",
        "btns": "electricity_voltage_changes"
    },
    {
        "id": 11,
        "original_english": "Partial",
        "english": "Partial",
        "original_arabic": "جزئي",
        "arabic": "جزئي",
        "btns": "reactivate_my_service"
    },
    {
        "id": 12,
        "original_english": "Voltage Problem",
        "english": "Voltage Problem",
        "original_arabic": "مشكلة الجهد",
        "arabic": "مشكلة الجهد",
        "btns": "alkahraba_friend"
    },
    {
        "id": 13,
        "original_english": "Outage",
        "english": "Outage",
        "original_arabic": "انقطاع",
        "arabic": "انقطاع",
        "btns": "account_billing"
    },
    {
        "id": 14,
        "original_english": "Connection Request",
        "english": "Connection Request",
        "original_arabic": "طلب توصيل",
        "arabic": "طلب توصيل",
        "btns": "move_in_out"
    },
    {
        "id": 15,
        "original_english": "Ticket or Request",
        "english": "Ticket or Request",
        "original_arabic": "تذكرة أو طلب",
        "arabic": "تذكرة أو طلب",
        "btns": "connection_request"
    },
    {
        "id": 16,
        "original_english": "Alkahraba Friend",
        "english": "Alkahraba Friend",
        "original_arabic": "صديق الكهرباء",
        "arabic": "صديق الكهرباء",
        "btns": "general_complaint"
    },
    {
        "id": 17,
        "original_english": "Aamin",
        "english": "Aamin",
        "original_arabic": "آمن",
        "arabic": "آمن",
        "btns": "fixed_bill"
    },
    {
        "id": 18,
        "original_english": "Report an outage",
        "english": "Report an outage",
        "original_arabic": "الإبلاغ عن انقطاع",
        "arabic": "الإبلاغ عن انقطاع",
        "btns": "installment_plan"
    },
    {
        "id": 19,
        "original_english": "Inquiry",
        "english": "Inquiry",
        "original_arabic": "استعلام",
        "arabic": "استعلام",
        "btns": "meter_inspection"
    },
    {
        "id": 20,
        "original_english": "Contract Account Number",
        "english": "Contract Account Number",
        "original_arabic": "رقم حساب العقد",
        "arabic": "رقم حساب العقد",
        "btns": "meter_inspection"
    },
    {
        "id": 21,
        "original_english": "Request Number",
        "english": "Request Number",
        "original_arabic": "رقم الطلب",
        "arabic": "رقم الطلب",
        "btns": "meter_inspection"
    },
    {
        "id": 22,
        "original_english": "Mobile Number",
        "english": "Mobile Number",
        "original_arabic": "رقم الجوال",
        "arabic": "رقم الجوال",
        "btns": "meter_inspection"
    }
];

export default iconList;